import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { isLogoPathValid } from "lib/validate";
import teachers2ParentsLogo from "components/assets/images/teachers/teachers-logo--new.svg";

import GenericSchoolLogo from "components/SchoolLogo";

export default class SchoolLogo extends React.Component {

  static propTypes = {
    school: ImmutablePropTypes.shape({
      serverHostname: PropTypes.string.isRequired,
      logoFileName: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired,
    cssBlockName: PropTypes.string
  }

  getLogoURL = () => {
    const { serverHostname, logoFileName } = this.props.school.toJS();
    if (logoFileName === "" || !isLogoPathValid(logoFileName)) {
      return teachers2ParentsLogo;
    }
    return `https://${serverHostname}/public/teachers/school_logo/${logoFileName}`;
  }

  render() {

    const { school, cssBlockName } = this.props;

    return <GenericSchoolLogo logoURL={this.getLogoURL()} schoolName={school.get("name")} cssBlockName={cssBlockName} cssModifier="teachers" />;

  }

}



// WEBPACK FOOTER //
// ./src/components/teachers/SchoolLogo.js